var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    {
      staticClass: "w-100",
      attrs: { "toggle-class": "border-0 bg-none m-md-2 text-dark" },
    },
    [
      _c("template", { slot: "button-content" }, [
        _c("img", {
          staticClass: "flag-nav",
          attrs: {
            src: _vm.language === "FR" ? _vm.logoFlagFR : _vm.logoFlagEN,
            alt: _vm.language === "FR" ? "Drapeau français" : "Drapeau anglais",
          },
        }),
        _vm._v(_vm._s(_vm.labelLanguage) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.options, function (option) {
        return _c(
          "b-dropdown-item",
          {
            key: option.value,
            on: {
              click: function ($event) {
                return _vm.languageCountry(option.value)
              },
            },
          },
          [
            option.value === "FR"
              ? _c("img", {
                  staticClass: "flag-nav",
                  attrs: { src: _vm.logoFlagFR, alt: "Drapeau français" },
                })
              : _c("img", {
                  staticClass: "flag-nav",
                  attrs: { src: _vm.logoFlagEN, alt: "Drapeau anglais" },
                }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(option.text))]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }